import { createLazyFileRoute } from "@tanstack/react-router";
import Page from "@/app/[tenantId]/[messengerId]/[hostConfig]/page";

export const Route = createLazyFileRoute("/$tenantId/$messengerId/$hostConfig/_launcherLayout/")({
  component: Component,
});
function Component() {
  const params = Route.useParams();
  return <Page params={params} />;
}
